<template>
  <div class="orderApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="order-tab">
      <span @click="toggle(1)" :class="{curt:1==active}">未付款</span>
      <span @click="toggle(2)" :class="{curt:2==active}">已付款</span>
      <span @click="toggle(3)" :class="{curt:3==active}">已过期</span>
      <span @click="toggle(4)" :class="{curt:4==active}">转移记录</span>
    </div>
    <div style="height:60px"></div>
    <div class="order-item" v-for="(item,i) in order">
      <div class="title">
        <div class="address" @click="toPush1(item.card_id,item.id,'retail')">{{item.name}} ({{item.phone}})</div>
        <block v-if="item.expired == 2 && item.status != 1">
        <div class="make" v-if="item.make_over != 1" @click="make(item.id)">转移他人</div>
        </block>
        <block v-if="item.expired == 1 && item.status != 1">
        <div class="make" style="color:#FF8544">未开始</div>
        </block>
        <block v-if="item.expired == 3 && item.status != 1">
        <div class="make" style="color:#FC0000">已过期</div>
        </block>
        <block v-if="item.status == 1">
        <div class="make" style="color:#576B95">未付款</div>
        </block>
      </div>
      <div class="product" @click="toPush1(item.card_id,item.id,'retail')">
        <div class="left">
          <div class="names">
            <div class="bt">{{item.title}}<span>×{{item.num}}</span></div>
            <div class="timer">使用时间:{{item.starttime}} 至 {{item.endtime}}</div>
            <div class="timer">{{item.createtime}}</div>
            <div class="timer" >订单编号：{{item.number}}
              <span><i>￥</i><b>{{item.price.split(".")[0]}}</b>
              <i>.{{item.price.split(".")[1]}}</i></span>
            </div>
          </div>
        </div>
      </div>
      <div class="rylcjs" style="line-height:20px;padding-top:8px" v-if="item.status != 1" @click="toPush(1,'img')">查看青秀山入园码<br>到景区扫码支付次数后才显示，当天有效 <img src="~assets/images/icon5.png"></div>
      <div class="rylcjs" v-if="item.status != 1" @click="toPush(1,'play1')">查看入园流程 <img style="margin-top:14px" src="~assets/images/icon5.png"></div>
    </div>  
    <div class="none"  v-if="order.length <= 0 ">
      <img src="~assets/images/no.png">
    </div>
    <div style="height:15px"></div>


    <el-dialog title="订单转移他人" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <div class="cardName">
        <div class="idCard">
          <span>证件类型</span> 身份证
        </div>
      </div>
      <div class="cardName">
        <div class="idCard">
          <span>转移人邀请码</span> <input type="text" v-model="yqcode" style="border:none;outline:none" placeholder="请输入邀请码">
        </div>
      </div>

      <div class="pzsc">
        <div class="left">
          <div>
            <span>姓<i>名</i>名</span>
            <font>{{name}}</font>
          </div>
          <div>
            <span>证件号</span>
            <font>{{sfz}}</font>
          </div>
        </div>
        
        <form class="right" @click="getQquey">
          <label for="file-input">
            <img src="~assets/images/ppp.png" />
          </label>
          <span>拍照识别</span>
        </form>
      </div>


      <div>
        <p>订单转移他人注意事项：</p>
        <p>1、订单转移后不可恢复，请谨慎操作。</p>
        <p>2、接受订单者，须提前关注公众号“职工生活家”，并进行身份验证及手机号验证。</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfin">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        userData:[],
        order:[],
        curHeight:0,
        fullscreenLoading: true,
        dialogFormVisible:false,
        active:1,
        baseUrl:'',
        name:'',
        sfz:'',
        order_id:0,
        yqcode:''
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      this.active = this.$route.query.id;
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    mounted() {
      this.beforeMount();
      this.getOrder();
    },

    methods: {
      toggle(index){
        this.active=index;
        this.getOrder();
      },
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },  
      backTop:function(){
        const that = this;
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
      },
      toPush1:function(index,id,url){
        this.$router.push({
          path:url,
          query:{
            id:index,
            oid:id
          }
        })
      },
      getOrder:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/order/index',
          params:{
            user_id:that.userData.id,
            status:that.active
          }
        }).then(function(response){
          that.fullscreenLoading = false
          var res = response.data.data;
          that.order = res
          
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      make:function(id){
        this.order_id = id;
        this.dialogFormVisible = true;
      },
      comfin:function(){
        var that = this;
        if(that.yqcode == ''){
          that.$alert('请输入邀请码', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/order/makeOver',
          params:{
            id:that.order_id,
            cardId:that.sfz,
            name:that.name,
            yqcode:that.yqcode
          }
        }).then(function(response){
          that.fullscreenLoading = false
          if(response.data.status == 200){
            that.getOrder();
            that.dialogFormVisible = false
          }else{
            alert(response.data.message)
          }
          
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      getQquey:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'chooseImage',
              'getLocalImgData'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['chooseImage'],
              success: function (res) {
                wx.chooseImage({
                  count: 1,
                  sizeType: ['compressed'],
                  sourceType: ['camera'], 
                  success: function(res) {
                      that.fullscreenLoading = true;
                      var localId = res.localIds[0].toString();
                      wx.getLocalImgData({
                          localId: localId, // 图片的localID
                          success: function(res) {
                            var u = navigator.userAgent;
                            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
                            var s = res.localData;
                            if(isAndroid){
                              s = 'data:image/jpg;base64,'+res.localData
                            }
                            that.getAjax(s)
                            //that.getAjax(res.localData.replace('data:image/jpeg/png;base64,',''))
                          }
                      });
                  }
                })
              }
            });
            
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      getAjax:function(localData){
        var that = this;
        $.ajax({
          url:this.$host+'home/user/sfCard',
          method: 'post',
          data:{
            localData:localData
          },
          success:function(msg){
            if(msg.status == 200){
              that.sfz = msg.data.num,
              that.name = msg.data.name
            }else{
              alert('身份证识别失败！');
            }
            that.fullscreenLoading = false;
          }
        })
      },

      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      }
    }
  };
</script>

<style>
  
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .el-message{
    top:auto !important;
    bottom:20px !important;
    min-width:70% !important;
  }
  .el-message{
    transition: opacity .3s,transform .4s,bottom .4s !important;
  }
  .el-dialog{
    width:90% !important;
  }
  .el-dialog__body{
    padding:20px 20px 0 20px !important;
  }
  .el-form-item__content{
    margin-left:0 !important
  }
  .el-form-item__label{
    text-align:left
  }
  .orderApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .orderApp .order-tab{
    position:fixed;
    width:100%;
    height:45px;
    left:0;
    top:0;
    background:#fff;
    z-index:99;
    border-bottom:solid 1px #ececec;
  }
  .orderApp .order-tab span{
    display:inline-block;
    width:25%;
    text-align:center;
    line-height:45px;
    font-size:15px;
    font-weight:bold;
    color:#666;
    position:relative;
  }
  .orderApp .order-tab span.curt{
    color:#333;
  }
  .orderApp .order-tab span.curt:after{
    position:absolute;
    content:'';
    width:30px;
    height:2px;
    background:#406DE1;
    bottom:5px;
    left:50%;
    transform: translateX(-50%);
  }
  .orderApp .order-item{
    width: 94%;
    display: block;
    margin: 0px auto 15px auto;
    background: #FFFFFF;
    border-radius: 5px;
  }
  .orderApp .order-item .title{
    height: 50px;
    display: block;
    line-height: 51px;
    border-bottom:solid 1px #EBF2FF;
    width:90%;
    margin:0 auto;
  }
  .orderApp .order-item .title .address{
    float: left;
    font-size: 16px;
    font-weight:bold;
  }
  .orderApp .order-item .title .make{
    float:right;
    font-size:14px;
    color:#406DE1;
  }
  .orderApp .order-item .product .left:after,.orderApp .order-item .btn:after{
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0
  } 
  .orderApp .order-item .product .left .names{
    float:left;
    margin-left:4%;
    position:relative;
    width:96%;
  }
  .orderApp .order-item .product .left .names .bt{
    font-size: 15px;
    color: #000;
    width: 100%;
    height:45px;
    line-height: 45px;
  }
  .orderApp .order-item .product .left .names .bt span{
    float:right;
    color:#666;
    margin-right:15px;
    font-size:16px;
  }
  .orderApp .order-item .product .left .names .timer{
    font-size: 14px;
    color: #999;
    padding-bottom:10px;
  }
  .orderApp .order-item .product .left .names .timer span{
    float:right;
    color:#FF6600;
    margin-right:15px;
    font-size:16px;
    margin-top:-5px;
    font-weight:bold
  }
  .orderApp .order-item .product .left .names .timer span b{
    color: #f00;
    font-size:17px;
    font-weight:500;
  }

  .orderApp .order-item .product .left .names .timer span i{
    color: #f00;
    font-size:12px;
    font-style:normal
  }
  .orderApp .none{
    text-align:center;
    padding-top:50%
  }
  .orderApp .none img{
    width:90%;
    display:block;
    margin:0 auto;
  }

.cardName{
    display:block;
    width:92%;
    margin:0 auto;
    margin-bottom:15px;
    position:relative
  }
  .cardName .idCard{
    display:block;
    border-bottom:solid 1px #f1f1f1;
    padding-bottom:10px;
    font-size:15px;
    color:#333;
  }
  .cardName .idCard span{
    font-size:15px;
    color:#333;
    padding-bottom:3px;
    padding-right:15px
  }
  .curtsss{
    border-top:solid 1px #f1f1f1;
  }
  .pzsc{
    display:block;
    width:92%;
    margin:0 auto;
    margin-bottom:5px;
  }
  .pzsc:after {
    content: '';
    height: 0;
    line-height: 0;
    display: block;
    visibility: hidden;
    clear: both;
  }
  .pzsc .left{
    float:left;
    width:75%;
  }
  .pzsc .left div{
    border-bottom:solid 1px #f1f1f1;
    padding:13px 0;
    font-size:15px;
  }
  .pzsc .left div:last-child{
    border-bottom:none
  }
  .pzsc .left div span{
    padding-right:15px
  }
  .pzsc .left div span i{
    opacity: 0
  }

  .pzsc .left div input{
    display:inline-block;
    font-size:15px;
    color:#333;
    outline:none;
    width:65%;
    border:none
  }

  .pzsc .right{
    float:left;
    width:25%;
    text-align:right;
    font-size:10px;
    position:relative
  }
  .pzsc .right:after{
    content:'';
    height:60px;
    width:1px;
    background:#f1f1f1;
    position:absolute;
    left:10px;
    top:20%;
  }
  .pzsc .right img{
    display:block;
    width:30px;
    height:30px;
    margin-left:50%;
    margin-bottom:5px;
    margin-top:15px
  }
  .pzsc .right > input{
    display: none;
  }

  .rylcjs{
    width:92%;
    margin:0 auto;
    height:40px;
    line-height:40px;
    border-top:solid 1px #EBF2FF;
    margin-top:10px;
    font-size:14px;
    color:#999
  }
  .rylcjs img{
    float:right;
    width:6px;
  }
</style>